export default __webpack_public_path__ + "static/media/p10.9871aa43.png";